module.exports = __webpack_public_path__ + "static/media/volume-off.c8f972aa.svg";